
import React from 'react';

// Componente WorkflowSection
interface WorkflowStepProps {
  number: string;
  title: string;
  desc: string;
  icon: string;
  colorClass: string;
}

const WorkflowStep: React.FC<WorkflowStepProps> = ({ number, title, desc, icon, colorClass }) => (
  <div className="relative flex flex-col items-center text-center p-6">
    <div className={`w-16 h-16 rounded-full ${colorClass} flex items-center justify-center text-2xl shadow-lg mb-6 relative z-10`}>
      <i className={icon}></i>
      <span className="absolute -top-1 -right-1 w-6 h-6 bg-dark text-white text-[10px] font-black rounded-full flex items-center justify-center">
        {number}
      </span>
    </div>
    <h4 className="text-lg font-black text-dark mb-3">{title}</h4>
    <p className="text-sm text-gray-500 font-medium leading-relaxed">
      {desc}
    </p>
  </div>
);

const WorkflowSection: React.FC = () => {
  return (
    <section id="workflow" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-black text-medical mb-4">
            Flujo de Datos OncoFHIR Prescribe
          </h2>
          <p className="text-lg text-gray-500 font-medium max-w-3xl mx-auto leading-relaxed">
            El ciclo completo conectado: desde que el oncólogo prescribe hasta que enfermería administra, cada paso está guiado y registrado automáticamente.
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-14 left-0 w-full h-0.5 bg-gray-100 -z-0"></div>
          
          <div className="grid md:grid-cols-3 gap-12 relative z-10">
            <WorkflowStep 
              number="1"
              title="Médico Prescribe"
              icon="fas fa-user-md"
              colorClass="bg-medical/10 text-medical"
              desc="Selección de protocolo. Cálculo automático de BSA y AUC (Calvert). Ajustes de dosis con alertas y visualización del historial terapéutico."
            />
            <WorkflowStep 
              number="2"
              title="Farmacia Prepara"
              icon="fas fa-flask"
              colorClass="bg-onco/10 text-onco"
              desc="Recepción digital de la orden. Guía de reconstitución y dilución. Generación de etiquetas con código QR para validación segura."
            />
            <WorkflowStep 
              number="3"
              title="Enfermería Administra"
              icon="fas fa-mobile-alt"
              colorClass="bg-fhir/10 text-fhir"
              desc="Validación mediante escaneo de QR. Registro de administración desde cualquier dispositivo móvil o PC con movilidad total en sala."
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkflowSection;
